import { motion } from "framer-motion";
import { Phone, MessageCircle, MapPin, Clock } from "lucide-react";
import { BUSINESS, telHref, waHref } from "../lib/business";

export const Contact = () => {
    return (
        <section
            id="iletisim"
            data-testid="contact-section"
            className="relative bg-[#0F172A] text-white overflow-hidden"
        >
            <div className="absolute inset-0 grid-bg opacity-[0.08] pointer-events-none" />
            <div className="absolute -top-32 -right-32 w-[520px] h-[520px] rounded-full bg-[#0055FF]/20 blur-3xl pointer-events-none" />
            <div className="absolute -bottom-32 -left-32 w-[460px] h-[460px] rounded-full bg-[#25D366]/15 blur-3xl pointer-events-none" />

            <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 sm:py-28">
                <div className="max-w-3xl">
                    <div className="text-xs font-bold uppercase tracking-[0.2em] text-[#3D7BFF]">
                        İletişim
                    </div>
                    <h2 className="mt-3 font-black tracking-tighter text-3xl sm:text-4xl lg:text-5xl leading-[1.02]">
                        Tesisatçı arıyorsanız tek arama yeter.
                    </h2>
                    <p className="mt-4 text-slate-300 text-base sm:text-lg">
                        Aşağıdaki numarayı arayın veya WhatsApp'tan yazın — Kayseri'nin
                        7/24 <strong className="text-white">su tesisatçısı</strong> ekibi dakikalar içinde kapınızda.
                    </p>
                </div>

                <motion.a
                    href={telHref}
                    data-testid="contact-phone-link"
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6 }}
                    className="block mt-10 group"
                >
                    <div className="text-[14vw] sm:text-[10vw] lg:text-[8vw] font-black tracking-tighter leading-none bg-gradient-to-r from-white via-white to-[#3D7BFF] bg-clip-text text-transparent group-hover:from-[#25D366] group-hover:to-[#25D366] transition-all duration-500">
                        {BUSINESS.phonePretty}
                    </div>
                </motion.a>

                <div className="mt-10 flex flex-wrap items-center gap-4">
                    <a
                        href={telHref}
                        data-testid="contact-call-btn"
                        className="group relative inline-flex items-center gap-3 rounded-full bg-[#FF3B30] hover:bg-[#E6352B] text-white px-7 py-4 text-base font-bold shadow-[0_18px_40px_-14px_rgba(255,59,48,0.7)] transition-all hover:scale-[1.03] active:scale-95"
                    >
                        <span className="absolute inset-0 rounded-full bg-[#FF3B30] pulse-ring -z-10" />
                        <Phone className="w-5 h-5" strokeWidth={2.5} />
                        Hemen Ara
                    </a>
                    <a
                        href={waHref}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="contact-whatsapp-btn"
                        className="inline-flex items-center gap-2 rounded-full bg-[#25D366] hover:bg-[#1EBE5D] text-white px-7 py-4 text-base font-bold shadow-[0_18px_40px_-14px_rgba(37,211,102,0.6)] transition-all hover:scale-[1.03] active:scale-95"
                    >
                        <MessageCircle className="w-5 h-5" strokeWidth={2.5} />
                        WhatsApp'tan Yaz
                    </a>
                </div>

                <div className="mt-16 grid sm:grid-cols-3 gap-4">
                    {[
                        { Icon: MapPin, label: "Hizmet Bölgesi", value: "Kayseri ve İlçeleri" },
                        { Icon: Clock, label: "Çalışma Saatleri", value: "7/24 Aktif" },
                        { Icon: Phone, label: "Çağrı Hattı", value: BUSINESS.phonePretty },
                    ].map(({ Icon, label, value }) => (
                        <div
                            key={label}
                            className="rounded-2xl border border-white/10 bg-white/5 backdrop-blur-sm p-5"
                        >
                            <div className="flex items-center gap-3">
                                <div className="w-10 h-10 rounded-xl bg-white/10 flex items-center justify-center">
                                    <Icon className="w-5 h-5 text-[#3D7BFF]" strokeWidth={2.5} />
                                </div>
                                <div>
                                    <div className="text-[10px] font-bold uppercase tracking-widest text-slate-400">
                                        {label}
                                    </div>
                                    <div className="text-base font-extrabold text-white mt-0.5">{value}</div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Contact;
